import { render, staticRenderFns } from "./EmployeeModel_fix.vue?vue&type=template&id=ffce3bc0&scoped=true"
import script from "./EmployeeModel_fix.vue?vue&type=script&lang=js"
export * from "./EmployeeModel_fix.vue?vue&type=script&lang=js"
import style0 from "./EmployeeModel_fix.vue?vue&type=style&index=0&id=ffce3bc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffce3bc0",
  null
  
)

export default component.exports